import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

// Konfigurasjon for fargemodus
const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

// Globale stilregler
const styles = {
  global: (props) => ({
    "html, body, #root": {
      bg: mode("#ECF0E5", "#1D3C34")(props), // Light mode vs dark mode bakgrunn
      color: mode("#1D3C34", "#FFFFFF")(props), // Light mode vs dark mode tekstfarge
      fontFamily: "body",
      lineHeight: "base",
      minHeight: "100vh",
    },
    "*::placeholder": {
      color: mode("gray.500", "whiteAlpha.300")(props),
    },
    "*, *::before, *::after": {
      borderColor: mode("gray.300", "whiteAlpha.300")(props),
      wordWrap: "break-word",
    },
  }),
};

// Utvider standard Chakra-temaet med våre konfigurasjoner og stiler
const theme = extendTheme({ config, styles });

export default theme;
